<template>
  <div>
    <router-view />
    <AuthExpiryWatcher
      v-if="!isDataPortal"
      :check-every="15000"
      :warn-before-seconds="0"
    />
    <ImpersonationBanner v-if="!isDataPortal" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AuthExpiryWatcher from './components/mics/AuthExpiryWatcher.vue';
import ImpersonationBanner from './components/mics/ImpersonationBanner.vue';

const route = useRoute();
const isDataPortal = computed(
  () =>
    window.location.pathname === '/data-portal' ||
    window.location.pathname.startsWith('/data-portal/') ||
    route.matched.some((record) => record.meta.authDomain === 'data-portal'),
);
</script>
